import { queryClient } from '@/Root';
import { useFuels } from '@/core/domain/people/Fuels/Fuels.hooks';
import { Select, SelectProps } from 'antd';
import { forwardRef } from 'react';

interface Props {
  useCachedData?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FuelsSelect = forwardRef<any, SelectProps & Props>((props, ref) => {
  const cachedData = props.useCachedData
    ? queryClient.getQueryData(['fuels'])
    : undefined;
  const { data, isLoading } = useFuels(!cachedData);

  const fuels = data?.data;

  return (
    <Select
      ref={ref}
      {...props}
      loading={props.loading || isLoading}
      showSearch
      optionFilterProp="label"
      options={fuels?.map((fuel) => ({ value: fuel.id, label: fuel.name }))}
    />
  );
});

export default FuelsSelect;
